import { useEffect, useState } from 'react'
import '../style.scss'

interface ListSelectPopUpProps {
	label: string
	values: string[]
	currentValueIndex?: number
	onValueSelected?: (selectedValue: number) => void
}

type SubFilterListItem = {
	valueLabel: string,
	valueIndex: number
}

function ListSelectPopUp({label, values, currentValueIndex, onValueSelected}: ListSelectPopUpProps) {

	const [listInputValue, setListInputValue] = useState<string>('Search')
	const [currentValue, setCurrentValue] = useState<number | undefined>(currentValueIndex)
	const [listItemsArr, setListItemsArr] = useState<SubFilterListItem[]>([])

	useEffect(() => {
		setCurrentValue(currentValueIndex)
	}, [currentValueIndex])

	useEffect(() => {
		updateFilteredListArray(listInputValue)
	}, [listInputValue])

	const updateFilteredListArray = (newInputValue: string = '') => {
		let newItemsArr: SubFilterListItem[] = []
		values.forEach((label: string, index: number) => {
			if (newInputValue === '' || newInputValue === 'Search' || label.toUpperCase().includes(newInputValue.toUpperCase())) {
				newItemsArr.push({
					valueLabel: label,
					valueIndex: index
				})
			}
		})
		setListItemsArr(newItemsArr)
	}

	const listValueClicked = (index: number) => {
		if (currentValue === index) {
			// setCurrentValue(undefined)
			if (onValueSelected && currentValueIndex) {
				onValueSelected(index as number)
			}
		} else {
			// setCurrentValue(index)
			if (onValueSelected) {
				onValueSelected(index as number)
			}
		}
	}

	const listInputChange = (newValue: string) => {
		setListInputValue(newValue)
	}

	const valueIndicatorClicked = (index: number) => {
		if (onValueSelected) {
			onValueSelected(index as number)
		}
	}

	const clearValue = () => {
		// setCurrentValue(undefined)
		if (onValueSelected && currentValueIndex) {
			onValueSelected(currentValueIndex as number)
		}
		setCurrentValue(undefined)
	}

	return (
		<div className='select-pop-up-wrap'>
			<div className="select-pop-up-label">
				{label}
			</div>
			<input 
					className='select-pop-up-list-input'
					type='text'
					value={listInputValue}
					onChange={(evt) => {
						listInputChange(evt.target.value)
						// setListInputValue(evt.target.value)
					}}
					onFocus={() => {
						if (listInputValue === 'Search') {
							setListInputValue('')
						}
					}}
					onBlur={() => {
						if (listInputValue === '') {
							setListInputValue('Search')
						}
					}}
				/>
			<div className='select-pop-up-value-list-wrap'>
				{currentValue !== undefined && (
					<div
						className={`sub-filter-section-value-list-item selected`}
						onClick={() => clearValue()}
					>
						<div className='sub-filter-section-value-list-item-icon-wrap'>
							<img 
								src={`/imgs/icons/icon-language-list.svg`} 
								className='sub-filter-section-value-list-item-icon'
								alt='Language'
							/>
						</div>
						{values[currentValue as number]}
					</div>
				)}
				{listItemsArr.map((value: SubFilterListItem, index) => 
					<div
						className={`select-pop-up-value-list-item ${currentValueIndex === index ? 'selected' : ''}`}
						key={`selectValueLabel${index}`}
						onClick={() => listValueClicked(value.valueIndex)}
					>
						<div className='select-pop-up-value-list-item-icon-wrap'>
							<img 
								src={`/imgs/icons/icon-school.svg`} 
								className='select-pop-up-value-list-item-icon'
								alt='school icon'
							/>
						</div>
						{value.valueLabel}
					</div>
				)}
			</div>
		</div>
	)
}

export default ListSelectPopUp